import utils from '@imt/vue-toolbox/src/utils';

import {authedAxios} from '@/store';

export const getters = {
    isFeatureEnabled(state) {
        return (featureName) => {
            const feature = state.featureFlags?.find(item => item?.name === featureName);

            return !!(feature && feature.enabled);
        };
    },
};

export const mutations = {
    SET_FEATURE_FLAGS(state, data) {
        state.featureFlags = data;
    },
};

export const actions = {
    async fetchFeatureFlags({commit}) {
        const response = await authedAxios.get('/feature-flags/'),
            data = utils.dataFormatter.deserialize(response.data);

        commit('SET_FEATURE_FLAGS', data.features);

        return data;
    },
};

export const state = () => {
    return {
        featureFlags: null,
    };
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state: state(),
};
